import { render } from "./FriendsPage.vue?vue&type=template&id=00d7cd6a"
import script from "./FriendsPage.vue?vue&type=script&lang=js"
export * from "./FriendsPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__